import {
  useMutation,
  useQueryClient,
  type QueryKey,
} from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { invalidateQueryKeys } from './invalidateQueryKeys'

interface SweepstakeWinnersMessageData {
  sweepstakeWinnerIds: number[]
}

interface UsePostSweepstakeWinnerMessageProps {
  onSuccess?: () => void
  onError?: () => void
  invalidateQueryKeys?: readonly QueryKey[]
}

export const usePostSweepstakeWinnerMessage = ({
  onSuccess,
  onError,
  invalidateQueryKeys: queryKeysToInvalidate,
}: UsePostSweepstakeWinnerMessageProps) => {
  const queryClient = useQueryClient()

  const postSweepstakeWinnerMessage = useTypedApiClient({
    path: '/admin/sweepstake-winners/message',
    method: 'post',
  })

  return useMutation({
    mutationFn: async (request: SweepstakeWinnersMessageData) => {
      const { data } = await postSweepstakeWinnerMessage(request)
      return data
    },
    onSuccess: async () => {
      if (
        queryKeysToInvalidate !== undefined &&
        queryKeysToInvalidate.length > 0
      ) {
        await invalidateQueryKeys(queryClient, queryKeysToInvalidate)
      } else {
        await queryClient.invalidateQueries({
          queryKey: ['/sweepstakes'],
        })
      }

      onSuccess?.()
    },
    onError,
  })
}
